// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label[data-v-ca0ff320] {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 500;\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n}\n.input-holder[data-v-ca0ff320] {\n  display: flex;\n  align-items: center;\n  width: 60%;\n  height: 40px;\n}\n.input-holder .separator[data-v-ca0ff320] {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 500;\n  margin: 0 16px;\n}\n", ""]);
// Exports
module.exports = exports;
